import React from "react";
import cache, { cacheItems } from "../../framework/cache";
import { getImageUrl } from "../../framework/getImageUrl";

import {
  withTheme,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  ListItem,
  Badge,
  Avatar,
  ListItemText,
  Divider,
  List,
} from "@material-ui/core";
import {
  Close,
  AddCircleOutline,
  RemoveCircleOutline,
} from "@material-ui/icons";
// import Swipe from 'react-easy-swipe'
import s from "./favorites.module.css";
import { theme } from "../../framework/theme";
import GlobalContext from "../../context/globalContext";
import * as _ from "lodash";

// import { isBrowser } from 'react-device-detect'

class ModifyOrder extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      order: null,
      syncing: false,
      uptoDate: false,
    };
  }

  intervalID = 0;

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.createStateData();
    this.intervalID = setInterval(
      this.checkSubmitOrderChanges.bind(this),
      5000
    );
  }

  async componentWillUnmount() {
    clearInterval(this.intervalID);
    await this.checkSubmitOrderChanges();
  }

  async createStateData() {
    let { orderUuid } = this.props.match.params;

    let order = await this.context.global.apiGet({
      path: `/users/${cache.getItem(cacheItems.USER_UUID)}/orders/${orderUuid}`,
      auth: true,
    });

    order.calculatedInventoryItems = _.sortBy(order.calculatedInventoryItems, [
      "uuid",
    ]);

    this.setState({
      order: order,
    });
  }

  changeItemCount(item, subtractBoolean, quantity = 1) {
    if (!this.state.syncing && !this.state.order.isPaid) {
      const getstateList = this.state.order;
      let stateList = getstateList.calculatedInventoryItems;
      _.remove(stateList, (i) => {
        return i.uuid === item.uuid;
      });

      if (subtractBoolean) {
        let newQuantity = item.quantityInCart - quantity;
        item.oldQuantityInCart = item.oldQuantityInCart
          ? item.oldQuantityInCart
          : item.quantityInCart;
        item.quantityInCart = newQuantity > 0 ? newQuantity : 0;
      } else {
        let newQuantity = item.quantityInCart + quantity;
        item.oldQuantityInCart = item.oldQuantityInCart
          ? item.oldQuantityInCart
          : item.quantityInCart;
        item.quantityInCart =
          newQuantity > item.maxAllowedInCart
            ? item.maxAllowedInCart
            : newQuantity;
      }

      stateList.push(item);
      stateList = _.sortBy(stateList, ["uuid"]);
      getstateList.calculatedInventoryItems = stateList;
      this.setState({
        order: getstateList,
      });
    }
  }

  async checkSubmitOrderChanges() {
    console.log(this.state);
    if (!this.state.syncing && !this.state.order.isPaid) {
      this.setState({ syncing: true });
      let items = this.state.order.calculatedInventoryItems;
      let sendRequest = false;
      for (let item of items) {
        if (
          (item.oldQuantityInCart &&
            // eslint-disable-next-line eqeqeq
            item.quantityInCart != item.oldQuantityInCart) ||
          (item.oldQuantityInCart === 0 && item.quantityInCart > 0)
        ) {
          sendRequest = true;
        }
      }
      if (sendRequest) {
        await this.submitOrderChanges();
      }
      this.setState({ syncing: false });
    }
  }

  async submitOrderChanges() {
    let stateOrder = this.state.order;

    try {
      let order = await this.context.global.apiPatch({
        path: `/users/${cache.getItem(cacheItems.USER_UUID)}/orders/${
          stateOrder.uuid
        }`,
        auth: true,
        body: stateOrder,
      });

      order.calculatedInventoryItems = _.sortBy(
        order.calculatedInventoryItems,
        ["uuid"]
      );

      this.setState({ order });
    } catch (error) {
      this.createStateData();
    }
  }

  render() {
    const { order } = this.state;

    console.log(this.state);

    return (
      <>
        <AppBar className={s.shoppingCartAppBar}>
          <Toolbar className={s.shoppingCartToolbar}>
            <div className={s.appBarContentContainer}>
              <div className={s.addressContainer}>
                <Typography variant="body1" style={{ color: "white" }}>
                  Modify Order
                </Typography>
              </div>
            </div>
            <div className={s.closeButtonContainer}>
              <IconButton
                color="inherit"
                onClick={() => this.props.history.goBack()}
                aria-label="Close"
                className={s.shoppingCartAppBar}
              >
                <Close />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <div style={{ marginTop: "70px" }} />

        <Typography
          variant="body1"
          style={{
            // color: theme.palette.primary.main,
            color: "#222222",
            padding: "30px 20px",
            textAlign: "center",
          }}
        >
          All changes are immediately applied to the order.
        </Typography>

        {order && order.calculatedInventoryItems ? (
          <List className={s.shoppingCartListContainer}>
            <div>
              {order.calculatedInventoryItems.map((item) => {
                return (
                  <ShoppingListItem
                    key={item.uuid}
                    item={item}
                    changeItemCount={(item, subtractBoolean) =>
                      this.changeItemCount(item, subtractBoolean)
                    }
                    // removeItem={item => this.removeItem(item)}
                    // pendingUnFavorited={this.state.pendingUnFavorited}
                  />
                );
              })}
            </div>
          </List>
        ) : null}
        {/* <div style={{ margin: "2rem", display: "flex", flex: 1 }}>
          <Button
            onClick={async () => {
              await cache.setItem(
                cacheItems.POP_UP_LOCATION_INSTANCE_UUID,
                order.popUpLocationInstance.uuid
              );
              this.props.history.replace(`/dashboard`);
            }}
            style={{ flex: 1 }}
          >
            Need More Items? Place another order with no min purchase
            requirement.
          </Button>
        </div> */}
      </>
    );
  }
}

export default withTheme()(ModifyOrder);

class ShoppingListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      left: 0,
      fixed: false,
      addOrSubtract: "add",
      yPosition: 0,
    };
  }
  render() {
    const { item, changeItemCount } = this.props;

    return (
      <>
        <ListItem
          className={s.favorite_listItem}
          key={item.uuid}
          style={{
            left: this.state.left,
            marginLeft: this.state.left,
            minHeight: "150px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              minWidth: "130px",
              justifyContent: "space-between",
            }}
          >
            <div
              className={s.lessItemsButton}
              onClick={() => changeItemCount(item, true)}
            >
              <RemoveCircleOutline fontSize="large" />
            </div>

            {item.quantityInCart ? (
              <Badge badgeContent={item.quantityInCart} color="secondary">
                <Avatar src={getImageUrl(item.imageUrl)} />
              </Badge>
            ) : (
              <Avatar src={getImageUrl(item.imageUrl)} />
            )}

            <div
              className={s.moreItemsButton}
              onClick={() => changeItemCount(item, false)}
            >
              <AddCircleOutline fontSize="large" />
            </div>
          </div>

          <ListItemText
            style={{ padding: "0 16px 0 16px" }}
            className={s.listItemText}
            primary={
              <span style={{ fontSize: "smaller" }}>
                {!item.isSelect ? item.brand : null} {item.name}
              </span>
            }
            secondary={`${item.sizeDisplay}`}
          />
          <div className={s.itemPricesStack}>
            <div className={s.quantityPrice}>
              <div />
            </div>
            <div
              className={s.itemPrice}
              style={{ color: theme.palette.primary.main }}
            >
              ${(item.basePrice / 100).toFixed(2)}
            </div>
          </div>
        </ListItem>
        <Divider />
      </>
    );
  }
}
